import { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { MapPin } from 'lucide-react';
import { api, recordFunnelEvent } from '../api.js';
import { AppShell } from '../components/AppShell.js';
import { Button, Loading, Notice } from '../components/ui.js';
import { persistDraftForSession } from '../state/DraftContext.js';

interface ExchangeResult {
  venue: { id: string; name: string; city: string };
  language: 'en';
  expiresAt: number;
}

export function InvitationPage() {
  const { code = '' } = useParams();
  const navigate = useNavigate();
  const exchangeStarted = useRef(false);
  const [result, setResult] = useState<ExchangeResult | null>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (exchangeStarted.current) return;
    exchangeStarted.current = true;

    api<ExchangeResult>('/api/invitations/exchange', {
      method: 'POST',
      body: JSON.stringify({ code }),
    })
      .then((data) => {
        persistDraftForSession(data);
        setResult(data);
        window.history.replaceState({}, '', '/report/intake');
      })
      .catch(() => setError(true));
  }, [code]);

  const language = result?.language ?? 'en';
  return (
    <AppShell language={language}>
      <section className="center-card invitation-card">
        {error ? (
          <>
            <h1>Invitation unavailable</h1>
            <Notice tone="danger">
              This link may have expired or been disabled. Ask the venue team for a new QR code.
            </Notice>
          </>
        ) : !result ? (
          <Loading label="Checking your invitation..." />
        ) : (
          <>
            <div className="venue-icon">
              <MapPin aria-hidden />
            </div>
            <h1>Report a lost item</h1>
            <p>
              Invitation from <strong>{result.venue.name}</strong>, {result.venue.city}
            </p>
            <Button
              onClick={() => {
                void recordFunnelEvent({
                  type: 'REPORT_STARTED',
                  step: 'INTAKE',
                  language,
                }).finally(() => navigate('/report/intake'));
              }}
            >
              Start report
            </Button>
          </>
        )}
      </section>
    </AppShell>
  );
}
